<script setup lang="ts">
import BasePopoverItem from "./BasePopoverItem.vue";
import UsersIcon20x20 from "../../../icons/popovers/UsersIcon20x20.vue";
import { locale } from "../../../../locale";
import { toggleUserList } from "../../../../states/viewState";
const props = defineProps<{
  close: () => void;
}>();
const usersAction = () => {
  toggleUserList();
  props.close();
};
</script>
<template>
  <BasePopoverItem :text="locale.userlist" @click.stop="usersAction">
    <UsersIcon20x20 />
  </BasePopoverItem>
</template>
